import styled from 'styled-components';

export const ForwardContainer = styled.div.attrs({})`
  padding: 16px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

// Faixa de contexto: qual contrato está sendo movido e de onde ele sai.
export const ResumoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 18px;
`;

export const ResumoItem = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
`;

export const ResumoLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  color: #718096;
  white-space: nowrap;
`;

export const ResumoValue = styled.span`
  font-size: 16px;
  color: #2d3748;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// O aviso é o motivo de a ação pedir confirmação: a operação para a régua e
// não tem rota de volta que reabra os avisos cancelados.
export const AvisoBox = styled.div`
  background: ${(props) => props.$color || '#FF9500'}12;
  border-left: 4px solid ${(props) => props.$color || '#FF9500'};
  border-radius: 6px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const AvisoTitulo = styled.strong`
  font-size: 14px;
  color: #2d3748;
`;

export const AvisoTexto = styled.span`
  font-size: 13px;
  color: #4a5568;
  line-height: 1.45;
`;

export const CompanyButtonContainer = styled.div.attrs({})`
  width: 100%;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`;
